import { XIcon } from '@heroicons/react/solid'
import { ReactNode } from 'react'

interface BaseModalProps {
  isVisible: boolean
  onClose?: () => void
  whiteCloseIcon?: boolean
  children: ReactNode
  size?: 'sm' | 'md' | 'lg'
}

const BaseModal = ({ isVisible, onClose, whiteCloseIcon, children, size = 'md' }: BaseModalProps) => {
  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
  }

  if (!isVisible) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-neutral-900/60 backdrop-blur-sm animate-fade-in"
        onClick={onClose}
      />
      <div className={`relative w-full ${sizeClasses[size]} bg-white rounded-2xl shadow-elevated animate-slide-up overflow-hidden`}>
        {onClose && (
          <button
            onClick={onClose}
            className={`absolute top-4 right-4 z-10 p-1 rounded-lg transition-colors ${
              whiteCloseIcon 
                ? 'text-white/80 hover:text-white hover:bg-white/10' 
                : 'text-neutral-400 hover:text-neutral-600 hover:bg-neutral-100'
            }`}
          >
            <XIcon className="h-5 w-5" />
          </button>
        )}
        {children}
      </div>
    </div>
  )
}

export default BaseModal
